import ICONS from "../Constants/Icons";
import { Chat } from "../Models/Chat";
import { Image } from 'primereact/image';

interface ConversationChatProps {
  chats: Chat[];
}

const ConversationChat: React.FC<ConversationChatProps> = ({ chats }) => {
  const Icon = ICONS();

  const handleChatSelection = (chat: any) => {
    var element = document.getElementById(chat.id);
    if (element) {
      // element.style.paddingTop = "2%";
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      
    }
  };
  return (
    <div className="filter-buttons">
      {chats.map((chat: any) => (
        <div className="d-flex flex-column" onClick={() => handleChatSelection(chat)} key={chat.id}>
          <div className="d-flex justify-content-between align-items-center position-relative" style={{marginTop:"16px"}}>
            <div>
              <p className="mb-0" key={chat.id}>{chat.questionText}</p>
            </div>
            <div>
            {chat.star.isStared &&
            <Image className="chat-star d-flex align-items-center" src={Icon.StarResponseFilledIcon} alt="test-outline-star" height="20px" />}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConversationChat;
